import {
  getCurrentChannel,
  getCurrentCountryCode,
} from "../../../utils/countryConfigUtils";
import { getResolvedPid } from "../../attribution/runtime";
import { getHallAcquisitionContext } from "./hallAcquisition";
import type { HallAcquisitionContext } from "./hallAcquisition";
import { detectClientEnvironment, getClientPlatformInfo } from "../../clientEnv";

export interface EmRuntimeContext extends HallAcquisitionContext {
  countryCode: string;
  channel: string;
  pid: string;
  device: number;
  os: string;
  clientEnvKind: string;
  currentHost: string;
  host: string;
  currentPath: string;
  isLogin: boolean;
  isNative: boolean;
  isMobile: boolean;
  isFacebookFamilyIAB: boolean;
  openedFromApkCookie: boolean;
}

const getLocationPath = (): string => {
  if (typeof window === "undefined") {
    return "";
  }

  return `${window.location.pathname || ""}${window.location.search || ""}`;
};

export const getEmRuntimeContext = (): EmRuntimeContext => {
  const env = detectClientEnvironment();
  const platform = getClientPlatformInfo(env);
  const countryCode = (getCurrentCountryCode() || "").toLowerCase();
  const pid = getResolvedPid();
  const host = typeof window !== "undefined" ? window.location.host || "" : "";
  const currentPath = getLocationPath();
  const authToken =
    typeof window !== "undefined"
      ? window.localStorage.getItem("authToken") || ""
      : "";

  return {
    countryCode,
    channel: getCurrentChannel(),
    pid,
    device: platform.device,
    os: platform.os,
    clientEnvKind: env.kind,
    currentHost: host,
    host,
    currentPath,
    isLogin: !!authToken,
    isNative: platform.isNative,
    isMobile: platform.isMobile,
    isFacebookFamilyIAB: env.isFacebookFamilyIAB,
    openedFromApkCookie: env.cookies.isOpenedFromApk,
    ...getHallAcquisitionContext(),
  };
};

export const getInitialEmSuperProperties = (): Record<string, string | number | boolean> => {
  const context = getEmRuntimeContext();

  return {
    countryCode: context.countryCode,
    pid: context.pid,
    channel: context.channel,
    device: context.device,
    os: context.os,
    clientEnvKind: context.clientEnvKind,
    host: context.host,
    isLogin: context.isLogin,
    isNative: context.isNative,
    isMobile: context.isMobile,
    ...getHallAcquisitionContext(),
  };
};

export const getTrackCallbackProperties = (): Record<string, string | boolean> => {
  const context = getEmRuntimeContext();

  return {
    currentHost: context.currentHost,
    currentPath: context.currentPath,
    clientEnvKind: context.clientEnvKind,
    isLogin: context.isLogin,
    isFacebookFamilyIAB: context.isFacebookFamilyIAB,
    ...getHallAcquisitionContext(),
  };
};
